
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import react from "../assets/img/react.jpeg"
import node from "../assets/img/node.jpeg";
import mongo from "../assets/img/mongo.jpeg";
import express from "../assets/img/express.jpeg"
import tailwind from "../assets/img/tailwind.jpeg"
import aws from "../assets/img/aws.jpeg"


export const Skills = () => {

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>Skilled in responsive design, UX/UI principles, and agile methodologies, delivering robust and user-friendly web solutions. Strong communication and teamwork abilities fostered through collaboration in diverse startup and corporate environments, ensuring seamless project execution and client satisfaction.</p>
              <Row xs={2} md={6}>
                <Col>
                  <Image src={node} alt="web" fluid/>
                </Col>
                <Col>
                  <Image src={react} alt="web" fluid />
                </Col>
                <Col>
                  <Image src={mongo} alt="web" fluid />
                </Col>
                <Col>
                  <Image src={express} alt="web" fluid />
                </Col>
                <Col>
                  <Image src={tailwind} alt="web" fluid />
                </Col>
                <Col>
                  <Image src={aws} alt="web" fluid />
                </Col>
              </Row>

            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="background" />
    </section>
  )
}
